import Bowser from 'bowser';
import { logError } from './logger.utils';

export const isBrowserAndSystemValid = (): boolean => {
	try {
		const browserDetails = Bowser.parse(window.navigator.userAgent);

		if (!browserDetails) return false;

		if (!browserDetails.platform) return false;

		if (!browserDetails.platform.type) return false;

		if (browserDetails.platform.type !== 'desktop') return false;

		return true;
	} catch (err) {
		logError(err);

		return false;
	}
};
